import { Injectable } from '@angular/core';
import { Firestore, collectionData, collection, query, where, docData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Reporte } from '../interfaces/reporte';
import { Usuario } from '../interfaces/usuario';



@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private firestore: Firestore) { }

  getReportes(usuario: Usuario): Observable<Reporte[]>{
    const reportesRef = collection(this.firestore, 'reportes');
    const q = query(reportesRef, where('uidUsuario', '==', usuario.id));
    return collectionData(q, {idField: 'id'}) as Observable<Reporte[]>;
  }




}
